import { useClientBiography } from 'modules/onboarding/common/hooks';

import { OnboardingBiographyFormType } from '../../common/forms/onboardingBiographyForm';

import { useOnboardingContext } from './useOnboardingContext';

export const useOwnerBiography = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const { initialValues, saveBiography, submitLoading } = useClientBiography(
    data.ownerClient!
  );

  const onSubmit = async (values: OnboardingBiographyFormType) => {
    if (values) {
      await saveBiography(values);
      goToNext();
    }
  };

  return {
    onSubmit,
    goToBack,
    initialValues,
    submitLoading,
  };
};
